exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#app {\n  font-family: 'PingFangSC-Light', 'Avenir', Helvetica, 'Microsoft Yahei', Arial, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  margin: 0 auto;\n  background-color: white;\n  height: 100%;\n  color: #333;\n  position: relative;\n  max-width: 10rem;\n}\n.clearnMaxWidth {\n  max-width: none;\n}", ""]);

// exports
